import { defineMessages } from "react-intl";

export const messages = defineMessages({
  noResultsText: {
    id: "contactlist.noresults.text",
    defaultMessage: "No results",
    description: "Text to be shown when no results from contactlist",
  },
});
